// extracted by mini-css-extract-plugin
export default {"listGroup":"SkillHexagonListV2_listGroup__yDhI5","listGroupIndent":"SkillHexagonListV2_listGroupIndent__IImgr"};